import * as React from "react";
import {Provider} from 'react-redux'
import {store} from "../store";
import {Filebrowser} from "./filebrowser";
import {createRoot} from "react-dom/client";
import createCache from "@emotion/cache";
import {CacheProvider} from "@emotion/react";
import {ChakraProvider} from "@chakra-ui/react";
import {theme} from "../theme";

class FilebrowserWebComponent extends HTMLElement {
    connectedCallback() {
        let phraseConfigNode = document.getElementById('phraseConfig');
        if (phraseConfigNode instanceof HTMLScriptElement && phraseConfigNode.innerHTML !== null) {
            window.reacard.phraseConfig = JSON.parse(phraseConfigNode.innerHTML)
        }

        let folderId = parseInt(this.getAttribute("folderId"));

        const shadowRoot = this.attachShadow({mode: "open"});
        const root = document.createElement("duv");
        shadowRoot.appendChild(root);

        const cache = createCache({
            container: shadowRoot,
            key: "c"
        })

        const reactDom = createRoot(root);

        if (!isNaN(folderId)) {

            reactDom.render(
                <Provider store={store}>
                    <CacheProvider value={cache}>
                        <ChakraProvider theme={theme}>
                            <Filebrowser folderId={folderId}/>
                        </ChakraProvider>
                    </CacheProvider>
                </Provider>
            );
        }
    }
}

if (!customElements.get('file-browser')) {
    customElements.define('file-browser', FilebrowserWebComponent);
}
